import { workspaceActions } from '@pn/core/storage';
import { isEmpty } from 'lodash-es';
import React from 'react';
import { useIntelWorkspaceItemsStorage } from 'src/application/storage';

export function useAutoRemoveWorkspaceItems() {
  const { itemsToRemoveFromMap } = useIntelWorkspaceItemsStorage();

  React.useEffect(() => {
    if (isEmpty(itemsToRemoveFromMap)) return;
    itemsToRemoveFromMap.forEach((intelQuery) => {
      workspaceActions().removeFromWorkspace(intelQuery.id);
    });
  }, [itemsToRemoveFromMap]);
}
